module.exports = __webpack_public_path__ + "static/media/微波目标特性测量实验室2.38f862b9.jpg";